import React from 'react';

// A ReactNode can be a plain string, a number, or an arbitrary element tree
// (e.g. <span>Label</span>, an icon, a button) - toString() on a
// ReactElement just gives "[object Object]" (never contains any of the
// original text) and throws on null/undefined, so it can't tell us what the
// node actually renders as text. Recursively pull the real text content out
// instead.
export function getReactNodeText(node: React.ReactNode): string {
  if (node === null || node === undefined || typeof node === 'boolean') {
    return '';
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return node.toString();
  }
  if (Array.isArray(node)) {
    return node.map(getReactNodeText).join('');
  }
  if (React.isValidElement(node)) {
    const { children } = node.props as { children?: React.ReactNode };
    return getReactNodeText(children);
  }
  return '';
}
